import moment from 'moment';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showReportIncidentPopup } from '~/actions';
import { getShouldEnableNCNSRepostStates } from '~/growthbook';
import { RemoteConfigUtils } from '~/utils/RemoteConfigUtils';

export const useReportIncidentItem = (job) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.selectedChildOffice ?? state.user.user);

  const maxRepostTimeThreshold = RemoteConfigUtils.getMaxRepostTimeThreshold();

  const enabledStates = getShouldEnableNCNSRepostStates();
  const isEnabledState = enabledStates.includes(user?.address[0]?.state);

  // Checks if an incident has already been reported for the job
  const isReported = !!job?.incident;

  // Calculate minutes elapsed since shift start (positive = shift has started)
  const minutesSinceShiftStart = moment().diff(moment(job?.shift?.start), 'minutes');

  // Determines if the shift has started
  const isShiftNotStartedYet = minutesSinceShiftStart < 0;

  // Determines if the job can be reported (30+ minutes since shift start)
  const canReport = minutesSinceShiftStart >= 30;

  // shift already started but less than 30 minutes
  const isShiftStartedLessThan30Minutes =
    minutesSinceShiftStart >= 0 && minutesSinceShiftStart < 30;

  // Determines if the job can be reposted
  const canRepost = isEnabledState && canReport && minutesSinceShiftStart <= maxRepostTimeThreshold;

  const isButtonDisabled = isReported || !canReport || !canRepost;

  const onReportIncidentClick = useCallback(() => {
    dispatch(
      showReportIncidentPopup({
        job,
        professionalName: job?.professional?.full_name,
        canReport,
        canRepost,
      }),
    );
  }, [canReport, canRepost, dispatch, job]);

  return {
    isReported,
    canReport,
    canRepost,
    onReportIncidentClick,
    isShiftStartedLessThan30Minutes,
    isShiftNotStartedYet,
    isButtonDisabled,
  };
};
